import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  computed,
  input
} from '@angular/core';

import {
  ImmomioAccordionComponent,
  ImmomioAccordionContentDirective,
  ImmomioAccordionHeaderDirective,
  ImmomioAccordionItemDirective
} from '@immomio/ui/accordion';
import { InfoCollapseTypeEnum } from './info-collapse.enum';

@Component({
  selector: 'app-info-collapse',
  templateUrl: './info-collapse.component.html',
  styleUrls: ['./info-collapse.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ImmomioAccordionComponent,
    ImmomioAccordionItemDirective,
    ImmomioAccordionHeaderDirective,
    ImmomioAccordionContentDirective
  ]
})
export class InfoCollapseComponent {
  readonly type = input<InfoCollapseTypeEnum>(InfoCollapseTypeEnum.DEFAULT);
  // Like the ngb accordion this replaced, unset means open.
  readonly collapsed = input<boolean>();

  protected readonly statusIcon = computed(() => {
    switch (this.type()) {
      case InfoCollapseTypeEnum.INFO:
        return 'info';
      case InfoCollapseTypeEnum.POSITIVE:
        return 'check-framed';
      case InfoCollapseTypeEnum.DEFAULT:
        return 'question';
      default:
        return 'attention';
    }
  });
}
